import { Step } from 'react-joyride';

export const leadsPageTourSteps: Step[] = [
  {
    target: 'body',
    content: (
      <div>
        <h2 className="text-xl font-bold mb-2">Welcome to Leads Management! 🎉</h2>
        <p>This is where you manage all your leads. Let's take a quick tour to help you get started!</p>
      </div>
    ),
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="view-switcher"]',
    content: 'Switch between different views like Table view, Kanban board, and more to visualize your leads in different ways.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="search"]',
    content: 'Search for leads by name, email, or phone number. Type and press Enter to search.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="add-lead"]',
    content: 'Click here to add a new lead manually to your CRM.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="advanced-filters"]',
    content: 'Use advanced filters to narrow down your lead list with multiple criteria at once.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="owner-filter"]',
    content: 'Filter leads by their assigned owner or view unassigned leads. You can select multiple owners at once.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="apply-filters"]',
    content: 'After setting any filters, click Apply to see the filtered results. Active filters will be displayed below the toolbar.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="export"]',
    content: 'Export your leads to Excel, CSV, or other formats. You can export all leads or just the filtered results.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="column-settings"]',
    content: 'Customize which columns you want to see in your table. Your preferences will be saved automatically.',
    placement: 'left',
  },
  {
    target: '[data-tour="select-all"]',
    content: 'Use this checkbox to select all visible leads on the current page, or select individual leads by checking their rows.',
    placement: 'right',
  },
  {
    target: '[data-tour="table-row"]',
    content: 'Click on any lead row to view detailed information, add remarks, manage activities, and track the lead journey.',
    placement: 'top',
  },
  {
    target: '[data-tour="column-header"]',
    content: 'Click on column headers to sort your leads by that column. Click again to reverse the sort order.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="column-filter"]',
    content: 'Each column has its own filter. Click the filter icon to set specific criteria for that column.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="bulk-actions-hint"]',
    content: 'When you select one or more leads, bulk action buttons will appear here. You can change owner, export selected leads, add reminders, or delete multiple leads at once.',
    placement: 'bottom',
  },
  {
    target: 'body',
    content: (
      <div>
        <h2 className="text-xl font-bold mb-2">Tour Complete! 🎉</h2>
        <p className="mb-3">You're all set! You can restart this tour anytime by clicking the info icon in the toolbar.</p>
        <p className="text-sm text-gray-600">Happy lead managing!</p>
      </div>
    ),
    placement: 'center',
  },
];
